import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery'
import 'mapbox-gl/dist/mapbox-gl.css';
import App from './App';


ReactDOM.render(
  <App />,
  document.getElementById('root'),
  function(){
    $('#preloader').delay(0).fadeOut();
  }
);

